import React, { useState, useEffect } from "react";
import axios from "axios";
import { setGlobalVariable } from "../shared";
import { Accordion, Panel } from "rsuite";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import customLinkForLIONReource from "./customLinkForLIONReource";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useGlobalState } from '../state/index';

const Assessments = ({
  assessmentList,
  loadingResults,
  handleClick,
  activeTab,
  baseUrl,
}) => {
  const [intValue, setIntValue] = useState(null);
  const [activeKey, setActiveKey] = useState(0);
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);
  const [seAccessReadOnly] = useGlobalState("SEAccessReadOnly");
  const assessment = require("../menu_icons/etazo.png");
  const downArrow = require("../icons/downarrow.png");

  //Down arrow
  useEffect(() => {
    const scrollContainer = document.querySelector(".main-content");
    if (!scrollContainer) return;

    const handleScroll = () => {
      const bottom =
        scrollContainer.scrollTop + scrollContainer.clientHeight >=
        scrollContainer.scrollHeight - 10;
      setShowScrollIndicator(!bottom);
    };

    scrollContainer.addEventListener("scroll", handleScroll);

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(handleScroll);
    });

    resizeObserver.observe(scrollContainer);

    requestAnimationFrame(handleScroll);

    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
      resizeObserver.disconnect();
    };
  }, [assessmentList]);

  useEffect(() => {
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");
    const headers = {
      Authorization: `Bearer ${token}`, 
      "Content-Type": "application/json",
    };
    if (token != null) {
      axios
        .get(
          baseUrl +
          `Student/GetHelpPageId?studentkey=${studentkey}&districtId=${districtID}&url=${activeTab}`,
          { headers }
        )
        .then((response) => {
          console.log(response);
          const fetchedValue = response.data;
          setIntValue(fetchedValue);
          setGlobalVariable(fetchedValue);
          console.log("Fetched intValue:", fetchedValue);
        })
        .catch((error) => {
          console.error("Error fetching intValue:", error);
        });
    }
  }, []);

  // DATE COMPARATOR FOR SORTING
  function dateComparator(date1, date2) {
    var date1Number = _monthToNum(date1);
    var date2Number = _monthToNum(date2);

    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }

    return date1Number - date2Number;
  }

  function _monthToNum(date) {
    if (date === undefined || date === null || date.length !== 10) {
      return null;
    }

    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(0, 2);
    var dayNumber = date.substring(3, 5);

    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    // 29/08/2004 => 20040829
    return result;
  }

  function dateFormatter(params) {
    var dateAsString = params.value;
    var dateParts = dateAsString.split("-");
    return `${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`;
  }


  const reorderObjectArrays = (obj) => {
    const order = ["Today", "Pending", "Incomplete", "Upcoming", "Complete"]; // Define the desired order of arrays
    const reorderedObj = {};

    // Rebuild the object in the desired order
    order.forEach(key => {
      if (obj[key]) {
        reorderedObj[key] = obj[key];
      }
    });

    return reorderedObj;
  };

  // Reorder the arrays in the object
  const finalReorderedData = reorderObjectArrays(assessmentList);


  const etazoLogin = (props) => {
    const isDisabled = seAccessReadOnly || sessionStorage.getItem("SEAccessReadOnly") === "true";
    return (
      <div>
        <span className="etazoLoginImg">
          <img
            src={assessment}
            alt="Log In Icon"
            height={28}
            width={28}
            className="icon"
            onClick={() => !isDisabled && handleClick(props.data)}
            style={{ 
              opacity: isDisabled ? 0.5 : 1, 
              cursor: isDisabled ? "not-allowed" : "pointer" 
            }}
            title={isDisabled ? "Access is read-only" : ""}
          />
        </span>
      </div>
    );
  };

  // Column definitions for AG Grid (can be adjusted per data type)
  const columnDefs = [
    { headerName: "Title", field: "Title", filter: true },
    {
      headerName: "Release Date",
      field: "ReleaseDate",
      filter: true,
    },
    {
      field: "actions",
      headerName: "Etazo Login",
      cellRenderer: etazoLogin,
    },
  ];

  const data = {
    Incomplete: [
      {
        headerName: "Title", field: "Title", filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        flex: 3, minWidth: 300
      },
      {
        headerName: "Assessment Type", field: "AssessmentType", filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        flex: 1, minWidth: 100,
        cellStyle: {
          textAlign: "center", alignItems: "center",
        },
      },
      // {
      //   headerName: "Release Date",
      //   field: "ReleaseDate",
      //   filter: true, 
      //   filterParams: {
      //     buttons: ["reset", "cancel"],
      //     closeOnApply: true,
      //   },
      //   cellStyle: { textAlign: "center", alignItems: "center", }, flex: 1,minWidth: 120,sort: 'desc',  valueFormatter: dateFormatter, comparator: dateComparator,
      // },
      {
        headerName: "Submitted Date",
        field: "SubmittedDate",
        hide: false,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        cellStyle: { textAlign: "center", alignItems: "center" },
        flex: 1,
        minWidth: 120,
        sort: 'desc',
        valueFormatter: (params) => params.value ? dateFormatter(params) : "",
        comparator: dateComparator,
      },
      {
        field: "actions",
        headerName: "Etazo Login",
        cellRenderer: etazoLogin, cellStyle: { textAlign: "center", alignItems: "center", }, flex: 1, minWidth: 120
      },
    ],
    Complete: [
      {
        headerName: "Title",
        field: "Title",
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        flex: 3, cellStyle: { textAlign: "start", alignItems: "center", }, minWidth: 300
      },
      {
        headerName: "Assessment Type", field: "AssessmentType", filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        flex: 1, minWidth: 100,
        cellStyle: {
          textAlign: "center", alignItems: "center",
        },
      },
      // {
      //   headerName: "Release Date",
      //   field: "ReleaseDate",
      //   filter: true,
      //   filterParams: {
      //     buttons: ["reset", "cancel"],
      //     closeOnApply: true,
      //   },
      //   flex: 1, cellStyle: {
      //     textAlign: "center", alignItems: "center",
      //   },minWidth: 120,
      //   sort: 'desc',
      //   valueFormatter: dateFormatter,
      //   comparator: dateComparator,
      // },
      {
        headerName: "Submitted Date",
        field: "SubmittedDate",
        hide: false,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        cellStyle: { textAlign: "center", alignItems: "center" },
        flex: 1,
        minWidth: 120,
        sort: 'desc',
        valueFormatter: (params) => params.value ? dateFormatter(params) : "",
        comparator: dateComparator,
      },
    ],
    Upcoming: [
      {
        headerName: "Title",
        field: "Title",
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        flex: 3, cellStyle: {
          textAlign: "start", alignItems: "center",
        }, minWidth: 300,
      },
      {
        headerName: "Assessment Type", field: "AssessmentType", filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        flex: 1, minWidth: 100,
        cellStyle: {
          textAlign: "center", alignItems: "center",
        },
      },
      {
        headerName: "Release Date",
        field: "ReleaseDate",
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        flex: 1, cellStyle: {
          textAlign: "center", alignItems: "center",
        }, minWidth: 120,
        sort: 'desc',
        valueFormatter: dateFormatter,
        comparator: dateComparator,
      },
    ],
    Today: [
      {
        headerName: "Title", field: "Title", filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        flex: 3, minWidth: 300,
      },
      {
        headerName: "Assessment Type", field: "AssessmentType", filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        flex: 1, minWidth: 100,
        cellStyle: {
          textAlign: "center", alignItems: "center",
        },
      },
      {
        headerName: "Release Date",
        field: "ReleaseDate",
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        cellStyle: {
          textAlign: "center", alignItems: "center",
        }, flex: 1, minWidth: 120, sort: 'desc', valueFormatter: dateFormatter, comparator: dateComparator,
      },
      {
        field: "actions",
        headerName: "Etazo Login",
        cellRenderer: etazoLogin, cellStyle: {
          textAlign: "center", alignItems: "center",
        }, flex: 1, minWidth: 120
      },
    ],
    Pending: [
      {
        headerName: "Title", field: "Title", filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        flex: 3, minWidth: 300,
      },
      {
        headerName: "Assessment Type", field: "AssessmentType", filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        flex: 1, minWidth: 100,
        cellStyle: {
          textAlign: "center", alignItems: "center",
        },
      },
      {
        headerName: "Release Date",
        field: "ReleaseDate",
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        cellStyle: {
          textAlign: "center", alignItems: "center",
        }, flex: 1, minWidth: 120, sort: 'desc', valueFormatter: dateFormatter, comparator: dateComparator,
      },
      {
        field: "actions",
        headerName: "Etazo Login",
        cellRenderer: etazoLogin, cellStyle: {
          textAlign: "center", alignItems: "center",
        }, flex: 1, minWidth: 120
      },
    ],
  };

  const handleAccordionChange = (newActiveKey) => {
    // Prevent setting activeKey to empty array, keeping at least one panel open
    if (newActiveKey.length === 0) {
      setActiveKey(0); // Default to panel 1 if no panel is selected
    } else {
      setActiveKey(newActiveKey);
    }
  };

  const gridOptions = {
    icons: {
      sortAscending: '<span class="ag-icon ag-icon-desc">▲</span>',
      sortDescending: '<span class="ag-icon ag-icon-asc">▼</span>',
    },
  };

  const renderAssessmentsCards = () => {
    if (loadingResults) {
      return (
        <div className="spinner-container">
          <div className="spinner"></div>
          <p>Loading results...</p>
        </div>
      );
    }
    return (
      <div>
        <Accordion
          defaultActiveKey={activeKey}
          onChange={handleAccordionChange}
        >
          {Object.entries(finalReorderedData).map((entry, index) => {
            const category = entry[0];
            return (
              <Panel header={category} eventKey={index}>
                <div className="ag-theme-alpine" style={{ width: "100%" }}>
                  <AgGridReact
                    columnDefs={data[category]}
                    rowData={finalReorderedData[category]} // Dynamically pass the data for the specific key (Today or Next)
                    domLayout="autoHeight" // Automatically adjust height based on data
                    enableSorting={true} // Enable sorting in the grid
                    enableFilter={true} // Enable filtering in the grid
                    gridOptions={gridOptions}
                  />
                </div>
              </Panel>
            );
          })}
        </Accordion>
      </div>
    );
  };

  return (
    <>
      <div>{renderAssessmentsCards()}</div>

      {showScrollIndicator && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            background: "#d0cfcf99",
            color: "white",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "22px",
            zIndex: 9999,
            cursor: "pointer",
            animation: "bounce 1.5s infinite",
          }}
          onClick={() =>
            window.scrollBy({ top: 200, behavior: "smooth" })
          }
        >
          <img
            src={downArrow}
            alt="Scroll down"
            style={{ width: "22px", height: "22px" }}
          />
        </div>
      )}
    </>
  );
};

export default Assessments;
